import { render, staticRenderFns } from "./ServiceQuotationView.vue?vue&type=template&id=36beacba&"
import script from "./ServiceQuotationView.vue?vue&type=script&lang=js&"
export * from "./ServiceQuotationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports